import type { ByteReader } from '@core/core/types'
import { assert } from 'common/helpers'
import type { FaultId } from 'common/types'

import { baseURL } from '../common'
import { FileExportClient } from './__generated__/FileExport'
import type { HttpResponse } from './__generated__/http-client'
import { HttpClient } from './__generated__/http-client'

const httpClient = new HttpClient({ baseUrl: baseURL })

type ClientsType = 'FileExportClient'

const getClient = (clientName: ClientsType): FileExportClient => {
  switch (clientName) {
    case 'FileExportClient':
      return new FileExportClient(httpClient)
  }
}

export const fileExportHorizon3DApi = (interpretationId: string): Promise<ByteReader> => {
  const client = getClient('FileExportClient')
  return client
    .fileExportDownloadInterpretationHorizon3D(interpretationId)
    .then(convertResponseToReader)
}

export const get3DFileNameApi = (interpretationId: string): Promise<string> => {
  const client = getClient('FileExportClient')
  return client.fileExportGetHorizonInterpretation3DFileName(interpretationId).then(unfoldT)
}

export const fileExportHorizon2DApi = (interpretationId: string): Promise<ByteReader> => {
  const client = getClient('FileExportClient')
  return client
    .fileExportDownloadInterpretationHorizon2D(interpretationId)
    .then(convertResponseToReader)
}

export const get2DFileNameApi = (interpretationId: string): Promise<string> => {
  const client = getClient('FileExportClient')
  return client.fileExportGetHorizonInterpretation2DFileName(interpretationId).then(unfoldT)
}

export const getFaultFileNameApi = (faultId: FaultId): Promise<string> => {
  const client = getClient('FileExportClient')
  return client.fileExportGetFileNameFaultChm(faultId).then(unfoldT)
}

export const fileExportFaultApi = (faultId: FaultId): Promise<ByteReader> => {
  const client = getClient('FileExportClient')
  return client.fileExportDownloadFaultChm(faultId).then(convertResponseToReader)
}

const convertResponseToReader = (response: HttpResponse<File>): ByteReader => {
  const reader = response.body
  assert(reader != null)
  return reader
}

const unfoldT = <T>(response: HttpResponse<T>): T => response.data
